import { render, staticRenderFns } from "./session-item-professional-area.vue?vue&type=template&id=a3a4142c"
import script from "./session-item-professional-area.vue?vue&type=script&lang=ts"
export * from "./session-item-professional-area.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports